import { render, staticRenderFns } from "./files.vue?vue&type=template&id=3c1051ee"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports